import React from 'react';
interface OfferCardProps {
  title: string;
  subtitle: string;
  benefits: string[];
  buttonText: string;
  buttonHref: string;
  isPrimary?: boolean;
  imageSrc: string;
  imageAlt: string;
}
export function OfferCard({
  title,
  subtitle,
  benefits,
  buttonText,
  isPrimary = false,
  imageSrc,
  imageAlt
}: OfferCardProps) {
  const baseClasses = 'bg-white rounded-3xl relative flex flex-col h-full overflow-hidden transition-shadow duration-300';
  const primaryClasses = 'border-2 border-[#1D4ED8] shadow-[0_20px_40px_rgba(29,78,216,0.12)]';
  const secondaryClasses = 'border border-[rgba(0,0,0,0.06)] hover:shadow-[0_12px_30px_rgba(0,0,0,0.06)]';
  return <div className="relative h-full" data-id="element-126" data-mp="15gzf6sy1c8cw">
      {isPrimary && <div className="absolute top-0 inset-x-0 z-20 flex justify-center -translate-y-1/2 pointer-events-none" data-id="element-127" data-mp="15gg703y6syc2">
          <span className="bg-[#1D4ED8] text-white font-['Montserrat'] text-[10px] font-bold tracking-[0.15em] uppercase px-5 py-2 rounded-full shadow-[0_6px_16px_rgba(29,78,216,0.4)] whitespace-nowrap" data-id="element-128" data-mp="22ygb1t0xp0ag">
            ★ CEL MAI CĂUTAT!
          </span>
        </div>}
      <div className={`${baseClasses} ${isPrimary ? primaryClasses : secondaryClasses}`} data-id="element-129" data-mp="ddkydrj61s1r">
        <div className="relative aspect-[16/9] w-full overflow-hidden bg-[#0A1628]" data-id="element-130" data-mp="3vsdnxq26d16c">
          <img src={imageSrc} alt={imageAlt} className="w-full h-full object-cover" data-id="element-131" data-mp="3o1filvgdy6w" />
        </div>

      <div className="flex flex-col flex-1 p-8 text-center" data-id="element-132" data-mp="3lx26v13anhvf">
        <h3 className="font-['Montserrat'] text-[22px] font-bold text-[#09111F] mb-2 flex items-center justify-center min-h-[68px]" data-id="element-133" data-mp="3qull40zzrund">
          {title}
        </h3>
        <p className="font-['Inter'] text-[17px] text-[#6B7280] mb-8 flex items-center justify-center min-h-[56px]" data-id="element-134" data-mp="3gv32pozqcgxf">
          {subtitle}
        </p>

        <ul className="flex-1 flex flex-col justify-between gap-5 mb-8 text-left" data-id="element-135" data-mp="1b3ftrstj5sp5">
          {benefits.map((text, i) => <li key={i} className="flex items-start gap-3" data-id="element-136" data-mp="2o16n4aie3be9" data-mpi={i}>
              <div className="w-5 h-5 rounded-full bg-[#EFF6FF] flex items-center justify-center flex-shrink-0 mt-1" data-id="element-137" data-mp="2o2riu3gfx0dp">
                <svg className="w-3 h-3 text-[#1D4ED8]" fill="currentColor" viewBox="0 0 20 20" aria-hidden="true" data-id="element-138" data-mp="2j47tru6jv8h4">
                  <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" data-id="element-139" data-mp="2a3hz4tt0zo4z" />
                </svg>
              </div>
              <span className="font-['Inter'] text-[16px] font-light text-[#4B5563] leading-[1.6]" data-id="element-140" data-mp="2xx1afixk5und">
                {text}
              </span>
            </li>)}
        </ul>

        <a href="https://calendly.com/valerdura-coaching/sesiune-descoperire" target="_blank" rel="noopener noreferrer" className="mt-auto block w-full font-['Montserrat'] text-[15px] font-bold bg-[#1D4ED8] text-white px-6 py-4 rounded-xl shadow-[0_8px_20px_rgba(29,78,216,0.3)] hover:bg-[#2563EB] hover:-translate-y-0.5 transition-[background-color,transform,box-shadow] duration-200 ease-out text-center no-underline" data-id="element-141" data-mp="3qgzv0lyyvv9r">
          {buttonText}
        </a>
        </div>
      </div>
    </div>;
}